import { LABEL_SLOTS } from "./layout/constants";
const chunkIntoPages = (items, size = 10) => {
  const pages = [];
  for (let i = 0; i < items.length; i += size) {
    pages.push(items.slice(i, i + size));
  }
  return pages;
};

const slotForIndex = (indexOnPage) => {
  if (indexOnPage < 0 || indexOnPage > 9) {
    throw new Error(`slot invalido: ${indexOnPage}`);
  }
  return LABEL_SLOTS[indexOnPage];
};

export { chunkIntoPages, slotForIndex
};
